const DIALOG_EDITOR_NAMESPACE = 'jbp-partner-basic-info--locations-editor-dialog'

export const TRANSLATION_KEYS = {
  dialogHeader: `${DIALOG_EDITOR_NAMESPACE}--header-label`,

  locationsTextAreaPlaceholder: `${DIALOG_EDITOR_NAMESPACE}--locations-textarea-placeholder`,

  addButton: `${DIALOG_EDITOR_NAMESPACE}--add-button`,
  removeButton: `${DIALOG_EDITOR_NAMESPACE}--remove-button`,
  cancelButton: `${DIALOG_EDITOR_NAMESPACE}--cancel-button`,
  saveButton: `${DIALOG_EDITOR_NAMESPACE}--save-button`,
}
